<div class="bim360-models-tree-wrapper">

  <h3 class="title">{{ 'sources.bim360ModelsSelect.title' | translate }}</h3>

  <p class="select-model">{{ 'sources.bim360ModelsSelect.project' | translate }}:
    <span class="project-name">{{ data.project.Name }}.</span>
    {{ 'sources.bim360ModelsSelect.modelFormats' | translate }}
  </p>

  <div class="content">

    <ng-container *ngIf="isShowModelsTree; else noData">
      <tree-root
        #tree
        [nodes]="data.modelsTree" [options]="options"
        (select)="onSelectModels($event)"
        (deselect)="onDeselectModels($event)"
      ></tree-root>
    </ng-container>

    <ng-template #noData>
      <div class="no-files">
        <h4 class="no-files-title">{{ 'sources.bim360ModelsSelect.noFilesTitle' | translate }}</h4>
        <p class="empty-project">{{ 'sources.bim360ModelsSelect.projectIsEmpty' | translate }}</p>
      </div>
    </ng-template>

  </div>

  <div class="buttons">
    <button mat-raised-button class="cancel-button"
            (click)="onCloseDialog()"
    >{{ 'system.cancel' | translate }}</button>
    <button mat-button class="apply-button"
            [disabled]="!isShowModelsTree"
            (click)="onSaveModels()">{{ 'system.apply' | translate }}</button>
  </div>

</div>

